import {
  buildEpostStatusTimeline,
  EpostStatusTimelineTracking,
} from '../../../Epost'
import { Container } from '../../Container'
import {
  RAW_TIMLINE_WITH_TRACKING_ID,
  RAW_TIMLINE1,
  RAW_TIMLINE2,
  RAW_TIMLINE3,
} from '../EpostStatusTimeline.mocks'

import * as styles from './EpostStatusTimelineTrackingStatus.module.css'

function EpostStatusTimelineTrackingStatus() {
  return (
    <div className={styles.block}>
      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Tracking Status. Preparation, Shippable'
      >
        <EpostStatusTimelineTracking
          timeline={buildEpostStatusTimeline(RAW_TIMLINE1[0])}
        />
      </Container>
      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Tracking Status. Error'
      >
        <EpostStatusTimelineTracking
          timeline={buildEpostStatusTimeline(RAW_TIMLINE3[0])}
        />
      </Container>
      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Tracking Status. Preparation, Shippable, In production, Error'
      >
        <EpostStatusTimelineTracking
          timeline={buildEpostStatusTimeline(RAW_TIMLINE2[0])}
        />
      </Container>
      <Container
        contentClassName={styles.content}
        label='Epost Status Timline Tracking Status. All success, finished'
      >
        <EpostStatusTimelineTracking
          timeline={buildEpostStatusTimeline(RAW_TIMLINE_WITH_TRACKING_ID[0])}
        />
      </Container>
    </div>
  )
}

export default EpostStatusTimelineTrackingStatus
